import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import moment from 'moment';

//Components
import Loading from '../../../components/Loading/Loading';
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import RelatorioGeradoresPontoColetas from './RelatorioGeradoresPontoColetas';

//Helpers
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';

//Api
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';
import relatorio_api from '../../../api/relatorio_api';
import prefeitura_api from '../../../api/prefeitura_api';
import setor_api from '../../../api/setor_api';

function initialStateFiltros() {
    return {
        status: "Todos",
        cnpj: "",
        modalidadeId: 0,
        modalidadeId_selected: null,
        regional: 0,
        regional_selected: null,
        nomeRelatorio: "Relatórios - Geradores Ponto Coleta"
    }
}

export default function GeradoresPontoColetas() {
    //Variavel utilizada para navegação 
    const navigate = useNavigate();

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros());

    //Opções de modalidades de coleta
    const [optionsModalidades, setOptionsModalidades] = useState([]);

    //Opções do select de regionais
    const [optionsRegionais, setOptionsRegionais] = useState();

    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState([]);

    //Opções do select de status
    const optionsStatus = [
        { value: "Todos", text: "Todos" },
        { value: "Ativo", text: "Ativo" },
        { value: "Inativo", text: "Inativo" },
    ]

    const loadModalidades = () => {
        setLoading(true);
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao };
            });
            setOptionsModalidades(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    const loadRegionais = () => {
        prefeitura_api.GetList().then(responsePrefeitura => {
            setor_api.GetList(responsePrefeitura.data[0].id).then(response => {
                response.data = response.data.map(value => {
                    return { value: value.id, label: value.descricao }
                })
                setOptionsRegionais(response.data);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            })
        })
    }

    useEffect(() => {
        loadModalidades();
        loadRegionais();
    }, []);

    //Change para os campos data inicial, data final e status
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Change para os campos modalidade e localidade
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value.toString() : 0,
        });
    }

    //Função que puxa os dados do relatorio
    const carregarRelatorio = () => {
        setLoading(true);
        relatorio_api.RelatorioGeradoresPontoColetas(filtros).then(response => {
            setDadosRelatorio(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    if (dadosRelatorio.length > 0) {
        return <RelatorioGeradoresPontoColetas
            dadosRelatorio={dadosRelatorio}
            btnVoltar={() => setDadosRelatorio([])}
            filtros={filtros}
        />
    }

    return <MainCard btnVoltarInTop={() => navigate(-1)}>
        {loading && <Loading />}
        <h4>Relatório de Geradores por Ponto de Coleta</h4>
        <Row>
            <Col sm="12" md="6" lg="4">
                <TextField
                    name="cnpj"
                    label={"CNPJ"}
                    type={"text"}
                    mask={mascaras.cnpjMask}
                    maxLength={18}
                    value={filtros.cnpj}
                    onChange={onChangeFiltros}
                />
            </Col>
            <Col sm="12" md="6" lg="4">
                <TextField
                    placeholder='Todos'
                    name="regional_selected"
                    label={"Regional"}
                    type={"select"}
                    searchable
                    value={filtros.regional_selected}
                    onChange={onChangeSelected}
                    options={optionsRegionais}
                />
            </Col>
            <Col sm="12" md="6" lg="4">
                <TextField
                    name="status"
                    label={"* Status"}
                    type={"select"}
                    onChange={onChangeFiltros}
                    options={optionsStatus}
                    value={filtros.status}
                />
            </Col>
            <Col sm="12" md="6" lg="6">
                <TextField
                    placeholder='Todos'
                    name="modalidadeId_selected"
                    label={"Modalidade"}
                    type={"select"}
                    searchable
                    value={optionsModalidades.filter(x => x.value == filtros.modalidadeId)}
                    onChange={onChangeSelected}
                    options={optionsModalidades}
                />
                
            </Col>
            <Col sm="12" md="6" lg="6" style={{ marginTop: "1.875rem" }}>
                <Button
                    className='w-100 fw-bold'
                    color='info text-light'
                    onClick={carregarRelatorio}
                >
                    Gerar Relatório
                </Button>
            </Col>
        </Row>
    </MainCard>;
}